/**
 * Key-value storage.
 *
 * An in-memory map by default, so the app and its tests run without a native
 * module. Swap `setBackend` for AsyncStorage or encrypted storage at startup
 * in the real builds; nothing else changes.
 */

export interface StorageBackend {
  getItem(key: string): Promise<string | null>;
  setItem(key: string, value: string): Promise<void>;
  removeItem(key: string): Promise<void>;
}

class MemoryBackend implements StorageBackend {
  private readonly map = new Map<string, string>();

  async getItem(key: string): Promise<string | null> {
    return this.map.get(key) ?? null;
  }

  async setItem(key: string, value: string): Promise<void> {
    this.map.set(key, value);
  }

  async removeItem(key: string): Promise<void> {
    this.map.delete(key);
  }
}

let backend: StorageBackend = new MemoryBackend();

export function setBackend(next: StorageBackend): void {
  backend = next;
}

export const storage: StorageBackend = {
  getItem: (key) => backend.getItem(key),
  setItem: (key, value) => backend.setItem(key, value),
  removeItem: (key) => backend.removeItem(key),
};
